import { render, staticRenderFns } from "./UserDeleteData.vue?vue&type=template&id=adc11f50&"
import script from "./UserDeleteData.vue?vue&type=script&lang=js&"
export * from "./UserDeleteData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports